/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-07-06 10:12:45
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-07-06 14:17:21
 * @FilePath: \compmap\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'leaflet/dist/leaflet.css'
createApp(App).use(store).use(router).mount('#app')
